import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { TokenStorageService } from './token-storage.service';
import { AppConfig } from '../../app-config';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  observe: 'response' as 'body'
};

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  AUTH_API = "";

  constructor(private http: HttpClient,
              private tokenService: TokenStorageService,
              public jwtHelper: JwtHelperService,
              public appConfig: AppConfig
              ) {
                this.AUTH_API = appConfig.api_url;
              }

  login(credentials): Observable<any> {
    return this.http.post(this.AUTH_API  + 'login', JSON.stringify({
      correoElectronico: credentials.email,
      password: credentials.password
    }), httpOptions).pipe(tap(user => {
      console.log(user);
      return user;
    }));
  }

  register(user): Observable<any> {
    return this.http.post(this.AUTH_API  + 'signup', {
      name: user.name,
      email: user.email,
      password: user.password
    }, httpOptions);
  }

  public isAuthenticated(): boolean {
    const token = this.tokenService.getToken();

    return !this.jwtHelper.isTokenExpired(token);
  }
}
